import styled from "styled-components";
import {
	COLOR_BORDER_GREY,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_ERROR_RED,
	FONT_WT_BOLD,
	COLOR_WHITE,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const InputWrapper = styled.div`
	position: relative;
	input {
		height: 50px;
		width: 100%;
		border-radius: 3px;
		border: 1px solid ${COLOR_BORDER_GREY};
		font-size: 16px;
		display: inline-block;
		margin-right: 5px;
		padding: 15px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		box-sizing: border-box;
		&:focus {
			outline: none;
		}
	}
	.errorMessageWrapper {
		display: ${(props) => (props.error ? "unset" : "none")};
		.errorIcon {
			font-style: normal;
			top: 15px;
			background: ${COLOR_ERROR_RED};
			position: absolute;
			right: 16px;
			font-size: 12px;
			display: block;
			font-weight: ${FONT_WT_BOLD};
			height: 16px;
			width: 16px;
			padding-top: 1px;
			color: ${COLOR_WHITE};
			text-align: center;
			border-radius: 8px;
		}
		.errorMessage {
			position: absolute;
			right: -5px;
			bottom: 44px;
			background-color: ${COLOR_ERROR_RED};
			color: ${COLOR_WHITE};
			float: right;
			padding: 2px 10px;
			border-radius: 4px;
			margin-bottom: 9px;
			font-weight: ${FONT_WT_LIGHT};
			font-size: 12px;
			z-index: 100;
			padding: 10px;
			&:after {
				content: "";
				position: absolute;
				right: 20px;
				top: 100%;
				width: 0;
				height: 0;
				border-left: 8px solid transparent;
				border-right: 8px solid transparent;
				border-top: 8px solid ${COLOR_ERROR_RED};
				clear: both;
			}
		}
	}
`;
